import { PetAvatars } from "../../../components";
/* eslint-disable max-len */
import { Box, Divider, Typography } from "@mui/material";
import {
  AddToCalendarIcon,
  CallHospitalIcon,
  ClinicLocationIcon,
  CloseIcon,
  NewStethoScope,
  UserMailIcon,
} from "../../../components/Icons";
import React, { useState } from "react";
import { fromUnixToFullDateNum } from "../../../utils/unix-timestamp";

import { CREATE_BOOKING_TYPE, MODALS } from "../../../config/params";
import { MIXPANEL_EVENTS } from "../../../config/mixPanelEvents";
import { PromoCodeUsed } from "../../../components/PromoCode/PromoCode";
import { ReasonForVisitContainerStyled } from "../../containers/BookingReviewContainer/BookingReviewStyle";
import { getContactString } from "../../containers/ChangeHospitalContainer/ChangeHospitalContainer";
import { useAppointmentStore } from "../../../hooks/redux-hooks/appointment-store/appointment.store";
import { useModal } from "../../../context/ModalContext";
import { useBookingAppointmentTypeStore, useBookingReasonsNavigation } from "../../../hooks";
import { userActivityLogger } from "../../../utils/mixpanel";
import { StyledBookingFlowButton } from "../../containers/BookingScheduleContainer/BookingScheduleContainer.style";
import { formatDoctorNames } from "../../../utils/genericUtils";
import { RESCHEDULE_SOURCE, CUSTOMER_REFERRAL_SOURCES } from "../../../navigation/params";
import { getBookingMonth } from "../../../utils/bookingFlow";
import BookingReviewDetails from "../../../components/BookingReviewDetails/BookingReviewDetails";
import { IAppointmentCreateResponse } from "../../../services/create-appointment-v2/create-appointment-v2.interface";
const BookingConfirmationModal = () => {
  const { appointmentsResponse, appointmentsRescheduleResponse, setAppointmentResponse,
    setAppointmentsForm, setSelectedPets, setReasonForVisit, setRescheduleAppointmentsResponse } = useAppointmentStore();
  const { openModal, source, closeModal } = useModal();
  // eslint-disable-next-line no-unused-vars
  const [visit, setVisit] = useState<IAppointmentCreateResponse | null>(appointmentsResponse || appointmentsRescheduleResponse);
  const appointmentTime = fromUnixToFullDateNum(visit?.start_at!,
    visit?.location.timeZone);
  // eslint-disable-next-line no-unused-vars
  const { bookingAppointmentType, setBookingAppointmentType } = useBookingAppointmentTypeStore();
  const { resetReasonsNavigationStore }=useBookingReasonsNavigation();


  const handleOpenAddToCalendarModal = () => {
    const isDropOff = bookingAppointmentType === CREATE_BOOKING_TYPE.DROPOFF_BOOKING;
    const petNames = visit?.pets?.map((p) => p.name).join(",") ?? "";
    const noOfPets = visit?.pets?.length ?? 0;
    const eventDate = visit ?
      `${getBookingMonth(visit.start_at.toString(), visit.location.timeZone)} ${appointmentTime.day}` :
      undefined;

    userActivityLogger(
      isDropOff ? MIXPANEL_EVENTS.DROP_OFF_ADD_CALENDAR : MIXPANEL_EVENTS.ADD_CALENDAR,
      {
        appointment_category: isDropOff ? "drop_off" : "dvm",
        pet_name: petNames,
        no_of_pets: noOfPets,
        date: eventDate,
        time_slot: appointmentTime.time,
      },
    );
    openModal(MODALS.ADD_TO_CALENDAR);
  };

  const handleCloseIcon = () => {
    setSelectedPets([]);
    resetReasonsNavigationStore();
    setReasonForVisit({});
    setAppointmentsForm(null);
    setBookingAppointmentType(CREATE_BOOKING_TYPE.NORMAL_BOOKING);
    setAppointmentResponse(null);
    setRescheduleAppointmentsResponse(null);
    if (source !== RESCHEDULE_SOURCE.DASHBOARD) {
      openModal(MODALS.QUICK_SHARE_UPSELL_MODAL, CUSTOMER_REFERRAL_SOURCES.AFTER_BOOKING);
    } else {
      closeModal();
    }
  };

  const capitalizeFirstLetter = (string: string) => {
    return string.charAt(0).toLocaleUpperCase() + string.substring(1);
  };

  const bookingPetsName = visit?.pets?.map((item) => capitalizeFirstLetter(item.name))!;

  let petsName = "";

  for (let i = 0; i < bookingPetsName.length; i++) {
    if (bookingPetsName.length == 2) {
      petsName = bookingPetsName.join(" and ");
    } else if (bookingPetsName.length == 3) {
      petsName += i < bookingPetsName.length - 1 ? `${bookingPetsName[i]},` + " " : ` and ${bookingPetsName[i]}`;
    }
  }


  return (
    <>
      {visit && <Box className="h-full flex flex-col gap-6 overflow-hidden">
        <Box className="flex flex-col gap-2 grow-0 shrink text-center">
          <Box className="flex w-full justify-end cursor-pointer pr-3 pt-1" onClick={handleCloseIcon}>
            <CloseIcon /></Box>
          <Box className="flex w-full justify-center pt-[1rem]"><PetAvatars
            petDetails={visit?.pets} /></Box>
          <Typography className="!text-2xl !font-semibold">Woohoo!</Typography>

          {visit?.pets.length > 1 ? <Box>
            <Typography className="!text-base">
              Appointment booked for <span className="font-semibold">{petsName}!</span></Typography>
          </Box> :
            <Box>
              <Typography className="!text-base">
                Appointment booked for <span className="font-semibold">{visit?.pets[0].name}!</span>
              </Typography>
            </Box>}

        </Box>
        <Box className={`flex flex-col gap-2 grow overflow-y-auto pe-2 ${source === RESCHEDULE_SOURCE.DASHBOARD && "justify-around"}`}>
          <ReasonForVisitContainerStyled className="!p-6">
            <Box className="childContainer w-full !gap-4 max-w-full overflow-hidden">
              <Box className="flex gap-4 w-full">
                <img src="/assets/icons/newCalenderIcon.svg" alt="calendar icon" />
                <Box className="flex gap-[1px] items-start h-full w-fit border-b border-solid
                  border-gv-yellow pb-1">
                  <Typography variant="h4" className="font-semibold">{appointmentTime.weekday}</Typography>
                  <Divider orientation="vertical"
                    className="!self-center !mx-[0.2rem] !border-[1px] !border-gray-3 !h-3" />
                  <Typography variant="h4" className="!font-semibold">
                    {`${getBookingMonth(visit.start_at.toString(), visit.location.timeZone)} ${appointmentTime.day} ·`}
                  </Typography>
                  <Typography variant="h4" className="!font-semibold">
                    <span>{" "}{`${appointmentTime.time}`}</span>
                  </Typography>
                </Box>
              </Box>
              <Box className="flex gap-4 w-full">
                <ClinicLocationIcon width={24} height={24} color={"#262626"} />
                <Box className="flex flex-col gap-1">
                  <Typography variant="h4"><span className="font-semibold">GoodVets {" "}
                    {visit?.location.locationName}</span>
                  </Typography>
                  <Typography variant="subtitle1">{visit?.location.address}
                  </Typography>

                </Box>
              </Box>
              <Box className="border-b-2 w-full border-gray-3"></Box>
              <BookingReviewDetails modal="BookingConfirmation" />
              {bookingAppointmentType !== CREATE_BOOKING_TYPE.DROPOFF_BOOKING && visit &&
                visit?.resources?.length &&
                visit.resources[0].name &&
                (formatDoctorNames(visit.resources) !== "") &&
                <Box className="flex gap-4 font-semibold capitalize">
                  <NewStethoScope width={25} height={25} color={"#262626"} />
                  <Box>{formatDoctorNames(visit.resources)}</Box>
                </Box>
              }


              <Box className="border-b-2 w-full border-gray-3"></Box>

              <Box className="flex w-full flex-col gap-3">
                <Typography variant="body1" className="!font-semibold text-gray-1">Hospital Contact</Typography>
                <a className="!cursor-pointer" href={`mailto:${visit?.location.email}`}>
                  <Box className="flex gap-4 items-center">
                    <UserMailIcon width={24} height={24} />
                    <Typography variant="body1" className="!font-semibold !cursor-pointer">
                      {visit?.location.email}</Typography>
                  </Box>
                </a>
                <a className="!cursor-pointer" href={getContactString(visit?.location.phoneNumber)}>
                  <Box className="flex gap-4 items-center">
                    <CallHospitalIcon width={24} height={24} />
                    <Typography variant="body1" className="!font-semibold !cursor-pointer">
                      {visit?.location.phoneNumber}</Typography>
                  </Box>
                </a>
              </Box>

              {/* PromoCode */}

              <Box className="border-b-2 w-full border-gray-3"></Box>

              {visit.promoCode && visit.promoCode?.length > 0 && (
                <Box className="flex w-full flex-col gap-3">
                  <Typography variant="body1" className="!font-semibold text-gray-1">Promo Applied</Typography>
                  <Box className="w-fit">
                    {
                      visit.promoCode?.map((promo)=>(
                        <PromoCodeUsed key={promo} promoCodeUsed={promo}/>))
                    }
                  </Box>
                </Box>
              )}

              {/* PromoCode End*/}

            </Box>
          </ReasonForVisitContainerStyled>
        </Box>
        <div className="flex flex-col">
          {source !== RESCHEDULE_SOURCE.DASHBOARD &&
          <StyledBookingFlowButton
            color="primary"
            disabled={false}
            size="small"
            className="w-full !mb-3"
            onClick={handleCloseIcon}
          >
            Done
          </StyledBookingFlowButton>}
          <div
            className="flex gap-2 !sticky bottom-2 justify-center text-sm !bg-transparent py-3 px-8 cursor-pointer rounded-[6.25rem] w-full hover:!bg-gray-3 font-semibold"
            onClick={handleOpenAddToCalendarModal}>
            <AddToCalendarIcon />
            Add to Calendar
          </div>
        </div>
      </Box>}
    </>
  );
};

export default BookingConfirmationModal;
